import { useEffect, useState } from "react";
import { CheckCheck, Undo2 } from "lucide-react";

import { Aviso, Boton } from "./ui.tsx";

/** Cuánto se ofrece deshacer. Lo justo para notar que se pulsó lo que no era. */
export const SEGUNDOS_PARA_DESHACER = 10;

/**
 * «Listo · Deshacer» después de cada decisión (SPEC-029 §7, P-3).
 *
 * Deshacer guarda un ANULAR en el servidor: el pago vuelve a como lo dejó el
 * motor y consta quién se arrepintió y cuándo. Pasados diez segundos el botón
 * se va —para corregir después está Movimientos—, pero el mensaje se queda.
 */
export function AvisoHecho({
  texto,
  alDeshacer,
  deshaciendo,
}: {
  texto: string;
  /** Sin esto no se ofrece deshacer: un ANULAR no se deshace a sí mismo. */
  alDeshacer?: () => void;
  deshaciendo?: boolean;
}) {
  const [quedan, setQuedan] = useState(SEGUNDOS_PARA_DESHACER);

  useEffect(() => {
    if (!alDeshacer) return;
    const t = setInterval(() => setQuedan((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [alDeshacer]);

  return (
    <Aviso tono="exito" titulo="Listo" icono={CheckCheck}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>{texto}</span>
        {alDeshacer && quedan > 0 && (
          <Boton tamano="sm" variante="suave" icono={Undo2} cargando={deshaciendo} onClick={alDeshacer}>
            Deshacer ({quedan})
          </Boton>
        )}
      </div>
    </Aviso>
  );
}
